import React, { Fragment, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Button, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import { getRouteParams } from '../plugins/events';
function renderParams(params) {
    return params.map((param, index) => {
        return (React.createElement(Fragment, { key: `${param}-${index}` },
            React.createElement("strong", null, param),
            index < params.length - 1 ? ', ' : ''));
    });
}
const StyledAlertTitle = styled(AlertTitle) `
  font-size: 15px;
  font-weight: 600;
`;
const EditRouteDialog = ({ open, component, currentPath, parentPath, onChange, onCancel }) => {
    // remove leading slash
    currentPath = currentPath.substring(+currentPath.startsWith('/'));
    const [path, setPath] = useState(currentPath);
    const currentRouteParams = useMemo(() => {
        return getRouteParams(currentPath);
    }, [currentPath]);
    const routeParams = useMemo(() => {
        return getRouteParams(path);
    }, [path]);
    // show warning if route params changed
    const showWarning = useMemo(() => {
        return (currentRouteParams.length !== 0 &&
            !currentRouteParams.every(param => routeParams.includes(param)));
    }, [currentRouteParams, routeParams]);
    function handlePathChange(value) {
        value = value.substring(+value.startsWith('/'));
        const oldPath = `${parentPath}/${currentPath}`;
        const newPath = `${parentPath}/${value}`;
        // Recursively update child paths on client side. Server side will
        // handle updating child component paths.
        const updateChildRoutes = (component) => {
            if (component.type === 'route') {
                if (!component.props)
                    component.props = {};
                if (!component.props.path)
                    component.props.path = newPath;
                component.props.path = component.props.path.replace(oldPath, newPath);
            }
            for (const child of component.children || []) {
                updateChildRoutes(child);
            }
        };
        updateChildRoutes(component);
        onChange === null || onChange === void 0 ? void 0 : onChange(newPath);
    }
    useEffect(() => {
        setPath(currentPath);
    }, [currentPath]);
    return (React.createElement(Dialog, { fullWidth: true, open: open, onClose: onCancel },
        React.createElement(DialogTitle, null, "Edit Route"),
        React.createElement("form", { onSubmit: event => {
                event.preventDefault();
                handlePathChange(path);
            } },
            React.createElement(DialogContent, null,
                React.createElement(ConfigFieldControl, null,
                    React.createElement(TextField, { autoFocus: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Path', value: path, InputProps: { startAdornment: `${parentPath}/` }, onChange: event => setPath(event.target.value) })),
                React.createElement(Collapse, { in: showWarning },
                    React.createElement(Alert, { severity: 'warning' },
                        React.createElement(StyledAlertTitle, null, "Route Params Changed"),
                        "Route params changed from (",
                        renderParams(currentRouteParams),
                        ") to (",
                        renderParams(routeParams),
                        "). Components that have referenced this route and its params in their configuration may need to be updated."))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onCancel }, "Cancel"),
                React.createElement(Button, { variant: 'contained', color: 'primary', type: 'submit' }, "Submit")))));
};
export default EditRouteDialog;
//# sourceMappingURL=EditRouteDialog.js.map